/* eslint-disable */
export default function serializeSystem(data) {

  const item = data.data;


  if (item.relationships) {
    for (const relationType in item.relationships) {
      if (item.relationships[relationType] && item.relationships[relationType].data) {
        if (item.relationships[relationType].data.length) {
          for (const relationItem of item.relationships[relationType].data) {
            if (data.included && data.included.length) {
              for (const include of data.included) {
                if (include.type === relationItem.type && include.id === relationItem.id) {
                  relationItem.attributes = include.attributes;
                }
              }
            }
          }
        } else if (data.included && data.included.length) {
          for (const include of data.included) {
            if (include.type === item.relationships[relationType].data.type && include.id === item.relationships[relationType].data.id) {
              item.relationships[relationType].data.attributes = include.attributes;
            }
          }
        }
      }
    }
  }

  return item;
}



// WEBPACK FOOTER //
// ./js/serializers/system.js